import type { BrowserOptions } from '@sentry/browser';
import {
  parseFrontendSentryConfig,
  buildFrontendSentryOptions,
} from '@tov-plus/observability/sentry/frontend';
import { buildReleaseString } from '@tov-plus/observability/sentry/release';
import vendorsPackageJson from '../../package.json';

export function initVendorsSentry(): BrowserOptions | null {
  const config = parseFrontendSentryConfig(
    {
      dsn: (import.meta.env['VITE_SENTRY_DSN'] ??
        import.meta.env['PUBLIC_SENTRY_DSN']) as string | undefined,
      environment: (import.meta.env['VITE_SENTRY_ENVIRONMENT'] ??
        import.meta.env['PUBLIC_SENTRY_ENVIRONMENT']) as string | undefined,
      release: (import.meta.env['VITE_SENTRY_RELEASE'] ??
        import.meta.env['PUBLIC_SENTRY_RELEASE'] ??
        buildReleaseString('@tov-plus/vendors', vendorsPackageJson.version)) as
        | string
        | undefined,
      tracesSampleRate: (import.meta.env['VITE_SENTRY_TRACES_SAMPLE_RATE'] ??
        import.meta.env['PUBLIC_SENTRY_TRACES_SAMPLE_RATE']) as
        | string
        | undefined,
      enabled: (import.meta.env['VITE_SENTRY_ENABLED'] ??
        import.meta.env['PUBLIC_SENTRY_ENABLED']) as string | undefined,
    },
    'vendors',
    '@tov-plus/vendors',
  );

  if (!config.enabled) return null;

  return buildFrontendSentryOptions(config) as BrowserOptions;
}
